import { TvvAfschalingBesteldeRouteActie, TvvWijzigBesteldeRouteActie, useAcceptActie } from "@/entities/actie";
import { TVVBestelStatus } from "@/entities/tvv";
import { RoleGate, UserRole } from "@/features/auth";
import { ErrorDisplay, MessageBar, MessageBarGezien } from "@/shared/components";

type TvvMessageBarProps = {
    dossierId: string;
    status: TVVBestelStatus;
    actie: TvvWijzigBesteldeRouteActie | TvvAfschalingBesteldeRouteActie | undefined;
};

export function TvvMessageBar({ dossierId, status, actie }: TvvMessageBarProps) {
    const acceptActieMutation = useAcceptActie();
    if (status === TVVBestelStatus.Gestopt) {
        return <MessageBar>Deze TVV route is gestopt</MessageBar>;
    }

    if (status === TVVBestelStatus.StopAangevraagd) {
        return (
            <RoleGate roles={[UserRole.DEWIT, UserRole.TRANSVISION]}>
                <MessageBar>
                    De regievoerder heeft een aanvraag gedaan <b>om de TVV route te stoppen</b>.
                </MessageBar>
            </RoleGate>
        );
    }

    if (actie && actie.status === "Nieuw") {
        const acceptActie = () => {
            if (!acceptActieMutation.isPending) {
                acceptActieMutation.mutate({ dossierId, actieId: actie.id });
            }
        };
        return (
            <RoleGate roles={[UserRole.DEWIT, UserRole.TRANSVISION]}>
                <MessageBarGezien onClose={acceptActie} label={actie.type === "TvvAfschalingBesteldeRoute" ? "Afschalen" : "Gezien"}>
                    De regievoerder heeft <span className="font-bold">het aantal bussen</span> gewijzigd.
                    {acceptActieMutation.error && <ErrorDisplay error={acceptActieMutation.error} />}
                </MessageBarGezien>
            </RoleGate>
        );
    }

    return null;
}
